import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TocItem } from '@/hooks/useBlogDetail';

export default function BlogMobileTOC({ toc }: { toc: TocItem[] }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setOpen(false);
  };

  return (
    <div className="lg:hidden">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between rounded-xl border border-secondary-200 bg-white px-4 py-3 text-[13px] font-bold text-secondary-900"
      >
        <span>{t('blog.tableOfContents')}</span>
        <i
          className={`ri-arrow-down-s-line text-lg transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="mt-1 rounded-xl border border-secondary-200 bg-white p-3">
          <ul className="flex flex-col">
            {toc.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => handleClick(item.id)}
                  className="flex w-full items-center py-2.5 text-left text-[12px] font-medium text-secondary-700 transition-colors hover:text-primary-600"
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}